module.exports = __webpack_public_path__ + "assets/azlogo.png";